<!-- ========================================================================================
      Author: Alizadeh
========================================================================================== -->

<!-- <template src="./Bills.html">-->
<template>
  <vs-popup
    class="holamundo"
    popup-class="w-9/12"
    :title='`انتخاب نقش "` + username +`"`'
    :active.sync="popupActive"
  >
    <vx-card class="mb-2">
      <vs-table id="tbl2" ref="tbl2" :data="items" class="table-dark-inverted" search >
  
        <template slot="thead">
          <vs-th></vs-th>
          <vs-th sort-key="name">نام</vs-th>
          <vs-th sort-key="name">عنوان</vs-th>
          <vs-th></vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <vs-checkbox v-model="selectedRoles" :vs-value="tr.roleName"></vs-checkbox>
            </vs-td>
            <vs-td :data="tr.roleName">
              <span>{{tr.roleName}}</span>
            </vs-td>
            <vs-td :data="tr.roleDisplayName">
              <span>{{tr.roleDisplayName}}</span>
            </vs-td>
            <vs-td>
              <feather-icon
                v-if="tr.isAssigned"
                strokeWidth="2"
                icon="CheckCircleIcon"
                svgClasses="h-6 w-6 text-success"
              ></feather-icon>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      
        <div class="vx-row mt-5">
          <div class="vx-col w-full" style="justify-content: center; display: flex;">
              <vs-button color="primary"  @click="save()">ذخیره</vs-button>
          </div>
        </div>
    </vx-card>
    <!-- <commissions ref="CommissionsOfGroup" @success="fillTable"></commissions> -->
  </vs-popup>
</template>
<style>
</style>
<script>
// import Commissions from "./Commissions.vue";
export default {
  name: "user-roles",
  props: {},
  components: {
    // Commissions
  },
  data() {
    return {
      popupActive: false,
      items: [],
      username:'',
      userId:null,
      selectedRoles:[],
    };
  },
  methods: {
    show(userId,username='') {
      this.items = [];
      if (userId) {
        this.userId=userId;
      this.username=username;
        this.fillTable();
        this.popupActive = true;
      }
    },
    fillTable() {
      let loading = this.$vs.loading();
      let payload={
        params:{
          id:this.userId
        }
      }
      this.$http
        .get("/api/services/app/User/GetUserForEdit",payload)
        .then(response => {
          this.items = response.data.result.roles;
          this.selectedRoles= response.data.result.roles.filter(x=>x.isAssigned).map(x=>x.roleName);
          this.$vs.loading.close();
        }) //end success
        .catch(error => {
          console.log(error);
          this.$vs.loading.close();
        }); //end http
    },
    clear() {
      this.filter = "";
    },
    SetPageSize(val) {
      this.pageSize = val;
      this.pageNo = 1;
      this.fillTable();
    },
    save() {
      let loading = this.$vs.loading();

      let payload = {
        userId: this.userId,
        assignedRoleNames: this.selectedRoles,
      };
      this.$http
        .put(`/api/services/app/User/UpdateRoles`, payload)
        .then(response => {
          if (response.data.success) {
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: "نقشها با موفقیت ثبت شد"
            });
            this.popupActive = false;
            this.$emit("success");
          }
          this.$vs.loading.close();
        }) //end success
        .catch(error => {
          console.log(error);
          this.$vs.loading.close();
        });
    }
  }
};
</script>
